import React, { useState } from "react";
import { Layout, Menu, Drawer, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import "./MainHeader.css";

const { Header } = Layout;
const { useBreakpoint } = Grid;

function MainHeader() {
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [open, setOpen] = useState(false);

  const items = [
    { key: "/", label: <Link to="/">Home</Link> },
    {
      key: "/banho-de-ouro-semijoias",
      label: <Link to="/banho-de-ouro-semijoias">Banho de Ouro</Link>,
    },
    {
      key: "/banhos-diversos",
      label: <Link to="/banhos-diversos">Banhos Diversos</Link>,
    },
    {
      key: "vernizes",
      label: "Vernizes",
      children: [
        {
          key: "/vernizes/cataforetico",
          label: <Link to="/vernizes/cataforetico">Cataforético</Link>,
        },
        {
          key: "/vernizes/diamond",
          label: <Link to="/vernizes/diamond">Diamond</Link>,
        },
      ],
    },
    { key: "/contato", label: <Link to="/contato">Contato</Link> },
  ];

  return (
    <Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        width: "100%",
        background: "#111111",
        padding: isMobile ? " 16px" : "0 24px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {isMobile ? (
        <>
          {/* MENU ICON */}
          <div
            style={{
              width: 40,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <MenuOutlined
              style={{ color: "#d4b483", fontSize: 22 }}
              onClick={() => setOpen(true)}
            />
          </div>

          {/* LOGO CENTRALIZADO */}
          <div
            style={{
              marginTop: 40,
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Link to="/">
              <img
                src="/logo.png"
                alt="Gold Service"
                style={{
                  height: 36,
                }}
              />
            </Link>
          </div>

          {/* ESPAÇO DIREITA (pode virar CTA depois) */}
          <div style={{ width: 40 }} />
        </>
      ) : (
        <>
          {/* DESKTOP NORMAL */}
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src="/logo.png"
              alt="Gold Service"
              style={{ height: 40 }}
            />
          </Link>

          <Menu
            className="gold-menu"
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={items}
            style={{
              flex: 1,
              justifyContent: "center",
              background: "transparent",
              borderBottom: "none",
            }}
          />
        </>
      )}

      {/* DRAWER MOBILE */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={() => setOpen(false)}
        open={open}
        bodyStyle={{ padding: 0 }}
        headerStyle={{
          background: "#111111",
          color: "#fff",
          borderBottom: "1px solid #222",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          style={{
            height: "100%",
            borderRight: 0,
          }}
          onClick={() => setOpen(false)}
        />
      </Drawer>
    </Header>
  );
}

export default MainHeader;